import {
  BooleanParam,
  DateTimeParam,
  NumberParam,
  StringParam,
  withDefault,
} from 'use-query-params';

export const queryParams = {
  sourceCode: StringParam,
  optedIn: BooleanParam,
  from: DateTimeParam,
  to: DateTimeParam,
  desc: withDefault(BooleanParam, true),
  before: StringParam,
  after: StringParam,
  first: withDefault(NumberParam, 20),
};
